/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import { retrieveClientMaintenanceHistoryRequest } from 'modules/maintenance/actions';
import {
  ClientMaintenanceHistoryResponse,
  ClientMaintenanceHistoryRetrieveFields,
} from 'modules/maintenance/interfaces';
import MaintenanceHistory from 'components/MaintenanceHistory';

export interface Props {
  isLoadingClientHistoryMaintenance: boolean;
  clientMaintenanceHistory: ClientMaintenanceHistoryResponse;
  currentRequest: string;
  clientMaintenanceHistoryRetrieve: ClientMaintenanceHistoryRetrieveFields;
  currentRequestDate: string;
  retrieveClientMaintenanceHistoryRequest: (props) => void;
}

const MaintenanceHistoryClient = ({
  isLoadingClientHistoryMaintenance,
  clientMaintenanceHistory,
  clientMaintenanceHistoryRetrieve,
  currentRequest,
  currentRequestDate,
  retrieveClientMaintenanceHistoryRequest,
}: Props) => {
  return (
    <MaintenanceHistory
      currentRequest={currentRequest}
      currentRequestDate={currentRequestDate}
      maintenanceHistory={clientMaintenanceHistory}
      maintenanceHistoryRetrieve={clientMaintenanceHistoryRetrieve}
      isLoadingMaintenance={isLoadingClientHistoryMaintenance}
      retriever={retrieveClientMaintenanceHistoryRequest}
      context={'client'}
    />
  );
};

const mapStateToProps = ({
  maintenance: {
    isLoadingClientHistoryMaintenance,
    clientMaintenance,
    clientMaintenanceHistory,
    clientMaintenanceHistoryRetrieve,
  },
}: ApplicationState) => ({
  isLoadingClientHistoryMaintenance,
  clientMaintenance,
  clientMaintenanceHistory,
  clientMaintenanceHistoryRetrieve,
});

export default connect(mapStateToProps, {
  retrieveClientMaintenanceHistoryRequest,
})(MaintenanceHistoryClient);
